(function () {
  'use strict';

  var DESKTOP_MIN = 1024;
  var nav = document.querySelector('.vf-header-nav');
  if (!nav) return;

  var items = nav.querySelectorAll('.vf-nav__item--has-mega, .vf-nav__item--has-dropdown');
  var closeTimer = null;

  function isDesktop() {
    return window.innerWidth >= DESKTOP_MIN;
  }

  function setExpanded(item, expanded) {
    var link = item.querySelector('.vf-nav__link');
    if (link) link.setAttribute('aria-expanded', expanded ? 'true' : 'false');
  }

  function closeAll() {
    items.forEach(function (item) {
      item.classList.remove('vf-nav__item--open');
      setExpanded(item, false);
    });
  }

  function openItemMenu(item) {
    if (!isDesktop()) return;
    closeAll();
    item.classList.add('vf-nav__item--open');
    setExpanded(item, true);
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeAll, 180);
  }

  function cancelClose() {
    clearTimeout(closeTimer);
  }

  items.forEach(function (item) {
    var link = item.querySelector('.vf-nav__link');
    var panel = item.querySelector('.vf-mega, .vf-dropdown');

    item.addEventListener('mouseenter', function () {
      cancelClose();
      openItemMenu(item);
    });

    item.addEventListener('mouseleave', function () {
      scheduleClose();
    });

    if (panel) {
      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
    }

    if (link) {
      link.addEventListener('focus', function () {
        openItemMenu(item);
      });

      link.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          closeAll();
          link.blur();
        }
      });
    }
  });

  nav.addEventListener('mouseleave', scheduleClose);

  document.addEventListener('click', function (e) {
    if (!nav.contains(e.target)) closeAll();
  });

  window.addEventListener('resize', function () {
    if (!isDesktop()) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();

(function () {
  'use strict';

  var menus = document.querySelectorAll('[data-vf-customer-menu]');
  if (!menus.length) return;

  function closeAll(except) {
    menus.forEach(function (menu) {
      if (menu === except) return;
      menu.classList.remove('vf-customer-menu--open');
      var trigger = menu.querySelector('.vf-customer-menu__trigger');
      var panel = menu.querySelector('.vf-customer-menu__panel');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (panel) panel.hidden = true;
    });
  }

  menus.forEach(function (menu) {
    var trigger = menu.querySelector('.vf-customer-menu__trigger');
    var panel = menu.querySelector('.vf-customer-menu__panel');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      var isOpen = menu.classList.contains('vf-customer-menu--open');
      closeAll();
      if (!isOpen) {
        menu.classList.add('vf-customer-menu--open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
    });

    panel.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  document.addEventListener('click', function () {
    closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();

(function () {
  'use strict';

  var lightbox = document.getElementById('vf-search-lightbox');
  if (!lightbox) return;

  var STORAGE_KEY = 'vf_search_history';
  var MAX_HISTORY = 5;

  var triggers = document.querySelectorAll('.vf-search-trigger');
  var closeEls = lightbox.querySelectorAll('[data-vf-search-close]');
  var form = lightbox.querySelector('.vf-search-lightbox__form');
  var input = lightbox.querySelector('.vf-search-lightbox__input');
  var historyRoot = lightbox.querySelector('[data-vf-search-history]');
  var historyTitle = lightbox.querySelector('[data-vf-search-history-title]');
  var historyList = lightbox.querySelector('[data-vf-search-history-list]');
  var historyClear = lightbox.querySelector('[data-vf-search-history-clear]');
  var lastTrigger = null;

  function normalizeTerm(term) {
    return String(term || '').replace(/\s+/g, ' ').trim();
  }

  function readHistory() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return parsed
        .map(normalizeTerm)
        .filter(Boolean)
        .slice(0, MAX_HISTORY);
    } catch (err) {
      return [];
    }
  }

  function writeHistory(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_HISTORY)));
    } catch (err) {
      /* ignore quota / private mode */
    }
  }

  function addToHistory(term) {
    var clean = normalizeTerm(term);
    if (!clean) return;
    var next = [clean].concat(
      readHistory().filter(function (item) {
        return item.toLowerCase() !== clean.toLowerCase();
      })
    );
    writeHistory(next);
  }

  function clearHistory() {
    try {
      window.localStorage.removeItem(STORAGE_KEY);
    } catch (err) {
      /* ignore */
    }
    renderHistory();
  }

  function renderHistory() {
    if (!historyRoot || !historyList) return;

    var items = readHistory();
    historyList.innerHTML = '';

    if (!items.length) {
      historyRoot.hidden = true;
      return;
    }

    if (historyTitle) {
      historyTitle.textContent = historyRoot.getAttribute('data-label-recent') || '';
    }
    if (historyClear) {
      historyClear.textContent = historyRoot.getAttribute('data-label-clear') || '';
    }

    items.forEach(function (term, index) {
      var li = document.createElement('li');
      li.className = 'vf-search-lightbox__history-item';
      li.style.setProperty('--vf-history-i', String(index));

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'vf-search-lightbox__history-btn';
      btn.setAttribute('data-term', term);

      var icon = document.createElement('span');
      icon.className = 'vf-search-lightbox__history-icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.innerHTML =
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none">' +
        '<path d="M12 7v5l3 2" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"/>' +
        '<circle cx="12" cy="12" r="8.25" stroke="currentColor" stroke-width="1.75"/>' +
        '</svg>';

      var label = document.createElement('span');
      label.className = 'vf-search-lightbox__history-term';
      label.textContent = term;

      btn.appendChild(icon);
      btn.appendChild(label);
      li.appendChild(btn);
      historyList.appendChild(li);
    });

    historyRoot.hidden = false;
  }

  function openSearch(trigger) {
    lastTrigger = trigger || null;
    lightbox.hidden = false;
    lightbox.classList.add('vf-search-lightbox--open');
    document.body.classList.add('vf-search-open');
    renderHistory();

    triggers.forEach(function (el) {
      el.setAttribute('aria-expanded', 'true');
    });

    window.setTimeout(function () {
      if (input) {
        input.focus();
        input.select();
      }
    }, 60);
  }

  function closeSearch() {
    lightbox.classList.remove('vf-search-lightbox--open');
    lightbox.hidden = true;
    document.body.classList.remove('vf-search-open');

    triggers.forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  triggers.forEach(function (trigger) {
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (lightbox.classList.contains('vf-search-lightbox--open')) {
        closeSearch();
      } else {
        openSearch(trigger);
      }
    });
  });

  closeEls.forEach(function (el) {
    el.addEventListener('click', closeSearch);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && lightbox.classList.contains('vf-search-lightbox--open')) {
      closeSearch();
    }
  });

  if (form) {
    form.addEventListener('submit', function () {
      if (input) addToHistory(input.value);
    });
  }

  if (historyList) {
    historyList.addEventListener('click', function (e) {
      var btn = e.target.closest('.vf-search-lightbox__history-btn');
      if (!btn || !form || !input) return;
      var term = btn.getAttribute('data-term') || '';
      input.value = term;
      addToHistory(term);
      form.submit();
    });
  }

  if (historyClear) {
    historyClear.addEventListener('click', function (e) {
      e.preventDefault();
      clearHistory();
      if (input) input.focus();
    });
  }

  /* Si ya hay términos en la página de resultados, los guardamos también */
  if (input && input.value) {
    addToHistory(input.value);
  }
})();

(function () {
  'use strict';

  var menuTrigger = document.getElementById('showLeftPush');
  var mobileNav = document.getElementById('cbp-spmenu-s1');
  if (!menuTrigger || !mobileNav) return;

  function getMenuContainer() {
    return mobileNav.querySelector('.gf-menu-device-container');
  }

  function hasDrawerMenu(container) {
    return container && container.querySelector('ul.gf-menu li, ul.site-nav > li');
  }

  function getVfeNavRoot() {
    return document.querySelector('#vf-empresas .vfe-main-menu, #vf-pymes .vfe-main-menu, .vf-nav-mobile-vfe-source .vfe-main-menu');
  }

  function getVfeNavLabel(labelNode) {
    if (!labelNode) return '';
    var clone = labelNode.cloneNode(true);
    clone.querySelectorAll('.vfe-main-menu__chevron').forEach(function (el) {
      el.remove();
    });
    return clone.textContent.replace(/\s+/g, ' ').trim();
  }

  function buildMenuFromVfeNav(navRoot) {
    if (!navRoot) return null;

    var ul = document.createElement('ul');
    ul.className = 'site-nav gf-menu';

    navRoot.querySelectorAll('.vfe-main-menu__item').forEach(function (item) {
      var li = document.createElement('li');
      var topLink = item.querySelector(':scope > a.vfe-main-menu__link, :scope > .vfe-main-menu__link[href]');
      var dropdown = item.querySelector(':scope > .vfe-main-menu__dropdown');
      var href = topLink && topLink.getAttribute('href');
      var labelNode = topLink || item.querySelector(':scope > .vfe-main-menu__link');
      var label = getVfeNavLabel(labelNode);

      if (!label) return;

      if (dropdown && dropdown.querySelectorAll('a[href]').length) {
        li.className = 'dropdown mega-menu';
        var toggle = document.createElement('a');
        toggle.href = href || '#';
        toggle.className = 'menu__moblie';
        toggle.innerHTML = '<span>' + label + '</span>';
        li.appendChild(toggle);

        var sub = document.createElement('ul');
        sub.className = 'site-nav-dropdown';
        dropdown.querySelectorAll('a[href]').forEach(function (subLink) {
          var subLi = document.createElement('li');
          var a = document.createElement('a');
          a.href = subLink.getAttribute('href') || '#';
          a.innerHTML = '<span>' + subLink.textContent.replace(/\s+/g, ' ').trim() + '</span>';
          subLi.appendChild(a);
          sub.appendChild(subLi);
        });
        li.appendChild(sub);
      } else if (href) {
        var link = document.createElement('a');
        link.href = href;
        link.className = 'menu__moblie';
        link.innerHTML = '<span>' + label + '</span>';
        li.appendChild(link);
      }

      if (li.childNodes.length) ul.appendChild(li);
    });

    return ul.children.length ? ul : null;
  }

  function getDropdownPanel(li) {
    if (!li) return null;
    var toggle = li.querySelector(':scope > p.toogleClick');
    if (toggle) {
      var first = toggle.nextElementSibling;
      if (first && first.classList.contains('site-nav-dropdown')) return first;
      if (first && first.nextElementSibling && first.nextElementSibling.classList.contains('site-nav-dropdown')) {
        return first.nextElementSibling;
      }
    }
    return li.querySelector(':scope > ul.site-nav-dropdown');
  }

  function toggleDropdownLi(li, forceOpen) {
    var panel = getDropdownPanel(li);
    if (!panel) return;
    var toggle = li.querySelector(':scope > p.toogleClick');
    var open = typeof forceOpen === 'boolean' ? forceOpen : !li.classList.contains('is-open');
    li.classList.toggle('is-open', open);
    if (toggle) toggle.classList.toggle('mobile-toggle-open', open);
    panel.style.display = open ? 'block' : 'none';
  }

  function setupDrawerSubmenus() {
    var container = getMenuContainer();
    if (!container) return;

    /* Quitar toggles legacy en niveles anidados (generan hueco visual). */
    container.querySelectorAll('.site-nav-dropdown li.dropdown > p.toogleClick').forEach(function (btn) {
      btn.remove();
    });

    container.querySelectorAll('ul.site-nav > li.dropdown, ul.gf-menu > li.dropdown').forEach(function (li) {
      if (!li.querySelector(':scope > p.toogleClick')) {
        var btn = document.createElement('p');
        btn.className = 'toogleClick';
        btn.setAttribute('role', 'button');
        btn.setAttribute('tabindex', '0');
        btn.textContent = '+';
        li.insertBefore(btn, li.firstChild);
      }

      if (!li.classList.contains('is-open')) {
        var panel = getDropdownPanel(li);
        if (panel) panel.style.display = 'none';
      }
    });

    container.querySelectorAll('.site-nav-dropdown li.dropdown').forEach(function (li) {
      if (!li.classList.contains('is-open')) {
        var panel = getDropdownPanel(li);
        if (panel) panel.style.display = 'none';
      }
    });

    container.querySelectorAll('ul.gf-menu, ul.site-nav').forEach(function (nav) {
      nav.style.setProperty('display', 'block', 'important');
      nav.style.visibility = 'visible';
      nav.style.height = 'auto';
    });
  }

  function ensureMobileMenu() {
    var container = getMenuContainer();
    if (!container) return;

    var vfeNav = getVfeNavRoot();
    if (vfeNav) {
      var alreadyVfe = container.getAttribute('data-vf-mobile-source') === 'vfe';
      if (!alreadyVfe || !hasDrawerMenu(container)) {
        container.innerHTML = '';
        var built = buildMenuFromVfeNav(vfeNav);
        if (built) {
          container.appendChild(built);
          container.setAttribute('data-vf-mobile-source', 'vfe');
        }
      }
    } else if (!hasDrawerMenu(container)) {
      var source = document.querySelector('.vf-nav-mobile-source .site-nav-dropdown_inner')
        || document.querySelector('.nav-bar .site-nav-dropdown_inner');

      if (source && source.innerHTML.trim()) {
        container.innerHTML = source.innerHTML;
        container.removeAttribute('data-vf-mobile-source');
        var nav = container.querySelector('.site-nav');
        if (nav) {
          nav.classList.add('gf-menu');
          nav.classList.remove('nav');
        }
      }
    }

    if (hasDrawerMenu(container)) {
      setupDrawerSubmenus();
    }
  }

  function syncMenuAria() {
    var isOpen = mobileNav.classList.contains('cbp-spmenu-open');
    menuTrigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    menuTrigger.classList.toggle('active', isOpen);
    if (isOpen) {
      ensureMobileMenu();
    }
  }

  ensureMobileMenu();
  window.addEventListener('load', function () {
    ensureMobileMenu();
    window.setTimeout(ensureMobileMenu, 200);
  });
  window.addEventListener('resize', ensureMobileMenu);

  mobileNav.addEventListener('click', function (event) {
    var toggle = event.target.closest('p.toogleClick');
    if (toggle && mobileNav.contains(toggle)) {
      event.preventDefault();
      toggleDropdownLi(toggle.parentElement);
      event.stopPropagation();
      return;
    }

    var link = event.target.closest('a.menu__moblie, #cbp-spmenu-s1 .site-nav-dropdown > li.dropdown > a');
    if (link && mobileNav.contains(link)) {
      var li = link.closest('li.dropdown');
      if (li) {
        var panel = getDropdownPanel(li);
        if (panel && !li.classList.contains('is-open')) {
          event.preventDefault();
          toggleDropdownLi(li, true);
          event.stopPropagation();
          return;
        }
      }
    }

    event.stopPropagation();
  });

  var drawerObserver = new MutationObserver(syncMenuAria);
  drawerObserver.observe(mobileNav, { attributes: true, attributeFilter: ['class'] });

  document.querySelectorAll('.gf-menu-device-wrapper .close-menu').forEach(function (btn) {
    btn.addEventListener('click', function () {
      window.setTimeout(syncMenuAria, 0);
    });
  });
})();

(function () {
  'use strict';

  var themeNav = document.querySelector('#vf-empresas.vf-empresas-theme-shell .vfe-main-menu, #vf-empresas-theme-nav .vfe-main-menu');
  var pageNav = document.querySelector('#vf-empresas:not(.vf-empresas-theme-shell) .vfe-main-menu, #vf-pymes .vfe-main-menu');
  var root = document.documentElement;

  function syncOverlayGutter() {
    var icons = document.querySelector('.header-type-1 .menu_bar_right');
    if (!icons) return;
    var rect = icons.getBoundingClientRect();
    var gutter = Math.max(24, Math.round(window.innerWidth - rect.left + 16));
    root.style.setProperty('--vf-native-icons-gutter', gutter + 'px');
  }

  function syncThemeEmpresasNav() {
    if (!themeNav) return;

    var logo = document.querySelector('.header-type-1 .site-header__logo img, .header-type-1 .site-header__logo a');
    var menubar = document.querySelector('.header-type-1 .site-header__menubar');

    if (!logo || !menubar) {
      root.style.setProperty('--vfe-menu-row-top', '36px');
      root.style.setProperty('--vfe-menu-row-height', '72px');
      root.style.setProperty('--vfe-menu-left', '235px');
      root.style.setProperty('--vfe-menu-right', '18px');
      return;
    }

    var logoRect = logo.getBoundingClientRect();
    var rowRect = menubar.getBoundingClientRect();
    var top = Math.max(0, Math.round(rowRect.top));
    var height = Math.max(58, Math.min(104, Math.round(rowRect.height)));
    var left = Math.max(190, Math.round(logoRect.right + 24));
    var right = 18;

    if (rowRect.height > 105) {
      height = Math.max(62, Math.min(88, Math.round(logoRect.height + 28)));
      top = Math.max(0, Math.round(logoRect.top - (height - logoRect.height) / 2));
    }

    root.style.setProperty('--vfe-menu-row-top', top + 'px');
    root.style.setProperty('--vfe-menu-row-height', height + 'px');
    root.style.setProperty('--vfe-menu-left', left + 'px');
    root.style.setProperty('--vfe-menu-right', right + 'px');
  }

  function syncAll() {
    syncOverlayGutter();
    syncThemeEmpresasNav();
  }

  if (!themeNav && !pageNav) return;

  syncAll();
  window.addEventListener('resize', syncAll);
  window.addEventListener('load', syncAll);
  window.addEventListener('scroll', syncAll, { passive: true });
  setTimeout(syncAll, 300);
  setTimeout(syncAll, 1200);
})();

(function () {
  'use strict';

  var ANCHORS = {
    'vf-calc-app': true,
    'vf-lead-app': true,
    'plan-360': true
  };

  function samePage(href) {
    if (!href || href.charAt(0) === '#') return true;
    try {
      var url = new URL(href, window.location.origin);
      return url.pathname === window.location.pathname;
    } catch (err) {
      return href.indexOf('#') === 0;
    }
  }

  function scrollToAnchor(id, attempts) {
    var el = document.getElementById(id);
    if (!el) {
      if ((attempts || 0) < 40) {
        window.setTimeout(function () {
          scrollToAnchor(id, (attempts || 0) + 1);
        }, 100);
      }
      return false;
    }
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href]');
    if (!link) return;

    var href = link.getAttribute('href') || '';
    var hash = href.split('#')[1];
    if (!hash || !ANCHORS[hash] || !samePage(href)) return;

    event.preventDefault();
    event.stopPropagation();
    scrollToAnchor(hash);
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + hash);
    }
  }, true);

  window.addEventListener('load', function () {
    var hash = (window.location.hash || '').replace('#', '');
    if (hash && ANCHORS[hash]) {
      window.setTimeout(function () {
        scrollToAnchor(hash);
      }, 80);
    }
  });
})();
